import { Wallet as WalletType } from '@reown/appkit-wallet-button/react';
import { Wallet } from '@shared/constants';

export const WALLETS: {
  wallet: Wallet;
  title: string;
  connector: WalletType;
  deepLinkBase?: string;
}[] = [
  // { wallet: Wallet.binance, title: 'Binance Wallet' },
  {
    wallet: Wallet.metamask,
    title: 'Metamask',
    connector: 'metamask',
    deepLinkBase: 'https://metamask.app.link/dapp/'
  },
  {
    wallet: Wallet.trustWallet,
    title: 'Trust Wallet',
    connector: 'trust',
    deepLinkBase: 'https://link.trustwallet.com/open_url?coin_id=966&url='
  },
  { wallet: Wallet.safepal, title: 'SafePal', connector: 'safepal' },
  { wallet: Wallet.coinbaseWallet, title: 'Coinbase\nWallet', connector: 'coinbase' },
  { wallet: Wallet.tokenpocket, title: 'Token\nPocket', connector: 'tokenpocket' },
  { wallet: Wallet.walletconnect, title: 'Wallet\nConnect', connector: 'walletConnect' }
];
